import _ from 'lodash'

import { filterKeys, filters } from '../../configuration/filtering'

import {
  CLEAR_FILTER,
  RESET_FILTER_STATE,
  UPDATE_EXACT_MATCH_FILTERS,
  UPDATE_FILTER,
  UPDATE_MULTIPLE_FILTERS,
} from '../actions/applyFilters'

const initialState = _.reduce(filterKeys, (initialFilterState, key) => ({
  ...initialFilterState,
  [`${key}`]: _.get(filters, `[${key}].initialState`),
}), { matchExactly: [] })

export default function tourFilters(state = initialState, action) {
  switch (action.type) {
    case CLEAR_FILTER:
      return Object.assign({}, state, {
        [`${action.payload}`]: _.get(filters, `[${action.payload}].initialState`),
      })
    case RESET_FILTER_STATE:
      return initialState
    case UPDATE_EXACT_MATCH_FILTERS:
      return Object.assign({}, state, {
        matchExactly: action.payload,
      })  
    case UPDATE_FILTER:
      return Object.assign({}, state, {
        [`${action.payload.filterKey}`]: action.payload.filters,
      })
    case UPDATE_MULTIPLE_FILTERS:
      return Object.assign({}, state, {
        ...action.payload,
      })
    default:
      return state
  }
}

export const getFilters = state => _.get(state, 'filtersData')
export const getFilterSetByKey = (state, key) => _.get(state, `filtersData[${key}]`)
export const getIsFilterExactMatch = (state, key) => _.includes(_.get(state, 'filtersData.matchExactly', []), key)
export const getPickedFilterSetByKeys = (state, keys) => _.pick(_.get(state, 'filtersData'), keys)
